import type { Session } from '@change-corgi/core/session';

import { isGuest } from './isGuest';

export function isSessionStaff(session: Session) {
	return !isGuest(session) && !!session.user && !!session.user.roles && !!session.user.roles.staff;
}
